import { readCookies as e } from "./cookies/cookie-parser-util.js";
import { GA_CLIENT_ID_COOKIE_NAME as t, parseGaClientIdCookie as n } from "./cookies/ga-client-id.js";
import { ErrorResponse as r, createErrorResponse as i } from "./errorResponse.js";
import { i as a, n as o, r as s, t as c } from "./chunks/repubs-BojZE0nv.js";
import { getUserGroup as l } from "./getUserGroup.js";
import { REPUBS as u } from "@cx-modules/constants";
import { REPUB_COUNTRY as d, SUPPORTED_REPUB_NAMES as f } from "@cx-web/domain-types";
//#region src/repub-util.ts
function p(e) {
	return !!u[e];
}
//#endregion
//#region src/getPathExcludingRepubFromUrl.ts
function m(e, t) {
	if (!e) throw Error("repub is undefined");
	if (!p(e)) throw Error("repub not valid");
	let n = o(e), r = new URL(t), i = r.pathname;
	return n && i.startsWith(n) && (i = i.slice(n.length)), (i.startsWith("/") ? i.slice(1) : i) + r.search + r.hash;
}
//#endregion
//#region src/getPromiseResult.ts
var h = (e) => {
	if (e.status !== "rejected") return e.value;
}, g = (e, t) => {
	let n = h(e);
	if (n == null) throw new Response(null, {
		status: 500,
		statusText: t
	});
	return n;
}, _ = (e, t) => {
	if (e.status === "rejected") throw e.reason instanceof Response ? e.reason : new Response(null, {
		status: 500,
		statusText: t
	});
	if (e.value == null) throw new Response(null, {
		status: 500,
		statusText: t
	});
	return e.value;
};
//#endregion
//#region src/getRepubFromURL.ts
function v(e) {
	let t = e.pathname.split("/")[1]?.toUpperCase();
	return !p(t) || !u[t] ? u.OC.name : t;
}
//#endregion
//#region src/isErrorWithStatus.ts
var y = (e) => typeof e == "object" && !!e && "status" in e;
//#endregion
//#region src/myoc-base-path.ts
function b(e) {
	let t = e.toLowerCase();
	return t === "oc" ? "/myoddschecker" : `/${t}/myoddschecker`;
}
//#endregion
//#region src/repub-meta.ts
function x(e) {
	let t = Object.entries(u).reduce((t, [n, r]) => ({
		...t,
		[n]: e === r.name
	}), {}), n = e.toLowerCase(), r = f.some((e) => t[e]), i = r ? d[e] : "uk";
	return {
		repubIs: t,
		repubIsOCPlus: r,
		repubPath: o(e),
		repubHomeUrl: c(e),
		repubLowerCase: n,
		repubCountry: i
	};
}
function S(e) {
	let { repubIsOCPlus: t } = x(e);
	return t;
}
//#endregion
//#region src/updateI18nSingleton.ts
var C = /* @__PURE__ */ new WeakSet();
function w(e, t, n) {
	if (!C.has(e)) {
		e.init({
			lng: t,
			fallbackLng: "en-US",
			defaultNS: "label",
			resources: n,
			initImmediate: !1
		}), C.add(e);
		return;
	}
	e.language !== t && e.changeLanguage(t);
	for (let [t, r] of Object.entries(n)) if (r) for (let [n, i] of Object.entries(r)) e.addResourceBundle(t, n, i, !1, !0);
}
//#endregion
export { r as ErrorResponse, t as GA_CLIENT_ID_COOKIE_NAME, i as createErrorResponse, b as getMyOcBasePath, m as getPathExcludingRepubFromUrl, h as getPromiseResult, v as getRepubFromURL, c as getRepubHomeUrl, x as getRepubMetaFromRepub, o as getRepubPath, l as getUserGroup, y as isErrorWithStatus, S as isOcPlusRepub, p as isValidRepub, n as parseGaClientIdCookie, e as readCookies, s as removeRepubPrefix, a as repubs, _ as requireErrorAwarePromiseResult, g as requirePromiseResult, w as updateI18nSingleton };
